import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInSuggestedFilters2RowExperiment() {
  const isShowCounts2Row = useIsInExperiment(
    'car-merch-ui-srp-suggested-filters',
    'showcounts-2row'
  );
  const isHideCounts2Row = useIsInExperiment(
    'car-merch-ui-srp-suggested-filters',
    'hidecounts-2row'
  );

  return isShowCounts2Row || isHideCounts2Row;
}
